import { BladeProvider } from '@razorpay/blade/components';
import { bladeTheme } from '@razorpay/blade/tokens';
import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from './hooks/useAuth';
import { useIdleTimeout } from './hooks/useIdleTimer';
import { MainRoutes } from './router';

const App: React.FC = () => {
  const { isAuthenticated, isLoading, handleLogout } = useAuth();

  useIdleTimeout(
    handleLogout,
    (import.meta.env.VITE_AUTO_LOGOUT_TIME ?? 15) * 60 * 1000,
  );

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p>Loading authentication...</p>
      </div>
    );
  }

  return (
    <BladeProvider themeTokens={bladeTheme} colorScheme="light">
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center">
            Loading...
          </div>
        }
      >
        <Router>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <MainRoutes isAuthenticated={isAuthenticated} />
        </Router>
      </Suspense>
    </BladeProvider>
  );
};

export default App;
